"use client"
import ScrollingTagsBanner from "@/components/ScrollingTagsBanner/ScrollingTagsBanner";
import "./WhyChooseSection.scss";

const WhyChooseSection = ({ whyChoose }) => {

  const { title, description, cases, image } = whyChoose;
  return (
    <ScrollingTagsBanner
      title={title}
      description={description}
      image={image}
      imageAlt="Problems Project Pulse Solves"
      items={cases}
    />
  );
};


export default WhyChooseSection;